/**
 * <ThreadHatch> — la hachure d'une sortie de l'appli, la même dans la tuile (`<TutorSessionThread>`) et dans l'onglet
 * « Fil » du centre (`<TutorSessionReplay>`). Elle remplit la vue qui la porte : l'appelant la place et la dimensionne
 * (une vue en position absolue ; un style du thème posé sur `<Svg>` n'est pas appliqué au web). `spans` hachure plusieurs
 * plages d'une même rangée dans un seul dessin (les sorties d'une tuile), en pourcentages de sa largeur.
 */
import React, { useId } from "react"
import { View, StyleSheet as RNStyleSheet } from "react-native"
import Svg, { Defs, Pattern, Rect } from "react-native-svg"
import { StyleSheet, useUnistyles } from "react-native-unistyles"

export function ThreadHatch(props: { spans?: { left: `${number}%`; width: `${number}%` }[] }) {
    const { spans = [{ left: "0%", width: "100%" }] } = props
    const { theme } = useUnistyles()
    const id = `thread-hatch-${useId().replace(/[^a-zA-Z0-9]/g, "")}`
    return (
        <View pointerEvents="none" style={styles.fill}>
            <Svg width="100%" height="100%">
                <Defs>
                    <Pattern id={id} patternUnits="userSpaceOnUse" width={4} height={4} patternTransform="rotate(45)">
                        <Rect width={4} height={4} fill={theme.colors.surface} />
                        <Rect width={2} height={4} fill={theme.colors["text-muted"]} />
                    </Pattern>
                </Defs>
                {spans.map((span) => (
                    <Rect key={span.left} x={span.left} width={span.width} height="100%" fill={`url(#${id})`} />
                ))}
            </Svg>
        </View>
    )
}

const styles = StyleSheet.create(() => ({
    fill: { ...RNStyleSheet.absoluteFillObject },
}))
